exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".App__root___3neFT {\n  position: relative;\n  overflow-x: hidden;\n  width: 100%;\n}\n\n.App__header___2N_41 {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n}\n\n.App__disabled-pointer___1TJQa {\n  pointer-events: none;\n  -ms-touch-action: none;\n      touch-action: none;\n}\n\n.App__root___3neFT.App__overflowHidden___1R-do {\n  overflow: hidden;\n  height: 100vh;\n}\n", ""]);

// exports
exports.locals = {
	"root": "App__root___3neFT",
	"header": "App__header___2N_41",
	"disabled-pointer": "App__disabled-pointer___1TJQa",
	"disabledPointer": "App__disabled-pointer___1TJQa",
	"overflowHidden": "App__overflowHidden___1R-do"
};